document.addEventListener("DOMContentLoaded", () => {
 
  const descriptionElements = document.querySelectorAll(".product-description");

  descriptionElements.forEach((descriptionElements) => {
    const tables = descriptionElements.querySelectorAll("table");
    tables.forEach((table) => {
      const itemDiv = document.createElement("div");
      itemDiv.classList.add("scrollable-wrapper");
      table.parentNode.insertBefore(itemDiv, table);
      itemDiv.appendChild(table);
    });

    const videos = descriptionElements.querySelectorAll("iframe");
    videos.forEach((video) => {
        const itemDiv = document.createElement("div");
        itemDiv.classList.add("video-wrapper");
        video.parentNode.insertBefore(itemDiv, video);
        itemDiv.appendChild(video);
    });

  });

});
